import { render, staticRenderFns } from "./ReviewArticle.vue?vue&type=template&id=275d5ffe&scoped=true&"
import script from "./ReviewArticle.vue?vue&type=script&lang=js&"
export * from "./ReviewArticle.vue?vue&type=script&lang=js&"
import style0 from "./ReviewArticle.vue?vue&type=style&index=0&id=275d5ffe&prod&lang=css&"
import style1 from "./ReviewArticle.vue?vue&type=style&index=1&id=275d5ffe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275d5ffe",
  null
  
)

export default component.exports